<template>
  <div class="HomeEquityProposedOfferCardContainer">
    <ProposedOfferCardContainer
      v-bind="$attrs"
      :offer="offer"
      product-label="Imóvel em garantia"
      @partner-info-click="displayOfferDetailsModal = true"
      @brand-click="displayOfferDetailsModal = true"
      @offer-conditions-click="displayOfferDetailsModal = true"
      @action-forward-click="selectOffer"
    />
    <OfferDetailsModal
      v-if="displayOfferDetailsModal"
      :offer="offer"
      :busy="busy"
      :is-fullscreen-mobile="true"
      product-type="Imóvel em garantia"
      :display="displayOfferDetailsModal"
      @close="displayOfferDetailsModal = false"
      @submit="selectOffer"
    />
    <OfferPartnerTimeoutFeedbackDialog
      v-if="displayOfferPartnerTimeoutFeedbackDialog"
      :display="displayOfferPartnerTimeoutFeedbackDialog"
      :partner="offer.partner"
    />
    <UnexpectedPartnerOfferErrorFeedbackDialog
      v-if="displayUnexpectedPartnerOfferErrorFeedbackDialog"
      :display="displayUnexpectedPartnerOfferErrorFeedbackDialog"
      :offer-id="offer.offer_id"
      :partner="offer.partner"
      :step="cptdCurrentStep"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  isOfferSelected,
  isOfferWaitingForAgreementAcceptance,
  isOfferWaitingForDocumentUploads,
  partnerHasFullIntegration,
  waitForAResultWithOptions,
} from '@/helpers/offers'
import { OfferStatus, OfferSubStatus } from '@/data/common'
import { UnexpectedPartnerOfferStepEnum } from '@/helpers/offer-types'
import { GtmPushDataLayer } from '@/helpers/google'
import UnexpectedPartnerOfferErrorFeedbackDialog from '@/components/loans/UnexpectedPartnerOfferErrorFeedbackDialog.vue'
import OfferPartnerTimeoutFeedbackDialog from '@/components/loans/OfferPartnerTimeoutFeedbackDialog.vue'
import OfferDetailsModal from '@/components/commomComponents/modals/OfferDetailsModal.vue'
import ProposedOfferCardContainer from '@/containers/loans/ProposedOfferCardContainer.vue'
export default {
  name: 'HomeEquityProposedOfferCardContainer',
  components: {
    UnexpectedPartnerOfferErrorFeedbackDialog,
    OfferPartnerTimeoutFeedbackDialog,
    OfferDetailsModal,
    ProposedOfferCardContainer,
  },
  props: {
    offer: { type: Object, required: true },
  },
  data() {
    return {
      displayOfferDetailsModal: false,
      displayOfferPartnerTimeoutFeedbackDialog: false,
      displayUnexpectedPartnerOfferErrorFeedbackDialog: false,
      busy: false,
      errorMsg: 'Algo deu errado! Por favor tente novamente.',
    }
  },
  computed: {
    ...mapGetters({
      gtHomeEquityOfferSelected:
        'products/loans/home-equity/home-equity/gtHomeEquityOfferSelected',
      gtUser: 'user/user/gtUser',
    }),
    cptdCurrentStep() {
      return UnexpectedPartnerOfferStepEnum.SELECT
    },
  },
  methods: {
    ...mapActions({
      createFeedback: 'utils/feedback/createFeedback',
      actGetHomeEquityOfferById:
        'products/loans/home-equity/home-equity/actGetHomeEquityOfferById',
      actSelectHomeEquityOffer:
        'products/loans/home-equity/home-equity/actSelectHomeEquityOffer',
      actSetHomeEquityOfferSelected:
        'products/loans/home-equity/home-equity/actSetHomeEquityOfferSelected',
      actSetLastLoanInteraction: 'ui/user-activity/actSetLastLoanInteraction',
    }),
    async selectOffer() {
      this.busy = true
      const selectResponse = await this.actSelectHomeEquityOffer({
        offer: this.offer,
      })
      this.actSetLastLoanInteraction('home-equity')
      if (selectResponse?.status === 200) {
        // GTM EVENT
        GtmPushDataLayer({
          user_id: this.gtUser?.id ?? '',
          homeequity_accept_amount: this.offer?.amount ?? '',
        })
        return await this.waitCurrentOfferTurnsIntoSelected()
      } else {
        if (selectResponse === 'REDIRECTED_TO_PARTNER_PAGES') {
          this.actSetHomeEquityOfferSelected(this.offer)
          return
        }
        this.createFeedback({ text: this.errorMsg })
      }
      this.busy = false
    },
    async waitCurrentOfferTurnsIntoSelected() {
      const { offer_id, partner } = this.offer
      let offerResponse = null
      this.busy = true
      try {
        offerResponse = await waitForAResultWithOptions(
          {
            status: (os) =>
              [OfferStatus.ONGOING, OfferStatus.FATAL_ERROR].includes(os),
            sub_status: (oss) =>
              [
                OfferSubStatus.SELECTED,
                OfferSubStatus.WAITING_FOR_DOCUMENT_UPLOADS,
                OfferSubStatus.WAITING_FOR_AGREEMENT_ACCEPTANCE,
                OfferSubStatus.INFORMATION_INCORRECT,
              ].includes(oss),
          },
          async () => {
            return await this.actGetHomeEquityOfferById(offer_id)
          },
        )
        if (offerResponse?.offer_id) {
          this.actSetHomeEquityOfferSelected(offerResponse)
          if (
            isOfferSelected(offerResponse) ||
            isOfferWaitingForDocumentUploads(offerResponse) ||
            isOfferWaitingForAgreementAcceptance(offerResponse)
          ) {
            if (
              partnerHasFullIntegration({
                partner,
                product_type: 'home-equity',
              })
            ) {
              this.$router.push({
                path: `/contratacao/home-equity/${partner.toLowerCase()}/${offer_id}`,
              })
            } else {
              this.$router.push({
                path: `/oferta/aceita/${partner.toLowerCase()}/${offer_id}`,
              })
            }
          } else {
            this.displayUnexpectedPartnerOfferErrorFeedbackDialog = true
          }
        } else {
          this.displayOfferPartnerTimeoutFeedbackDialog = true
        }
      } catch (e) {
        if (e?.message === 'MAX_RETRIES_REACHED') {
          this.displayOfferPartnerTimeoutFeedbackDialog = true
        } else {
          this.createFeedback({ text: this.errorMsg })
        }
      }

      this.busy = false
    },
  },
}
</script>

<style lang="scss"></style>
